import {
  useAppDispatch,
  useAppSelector,
  contextLimitModalState,
  setShouldShowContextLimitModal,
} from 'src/store';
import { useCallback, useMemo } from 'react';

export const useContextLimitModal = () => {
  const { shouldShowContextLimitModal } = useAppSelector(
    contextLimitModalState,
  );
  const dispatch = useAppDispatch();

  const changeShouldShowContextLimitModal = useCallback(
    (value: boolean) => {
      dispatch(setShouldShowContextLimitModal(value));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      shouldShowContextLimitModal,
      changeShouldShowContextLimitModal,
    }),
    [shouldShowContextLimitModal, changeShouldShowContextLimitModal],
  );
};
